export const processContentForExport = (html: string): string => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Define styles mapping
    const styles: Record<string, string> = {
        h1: 'font-size: 2.25rem; font-weight: 700; line-height: 2.5rem; margin-top: 0.5rem; margin-bottom: 0.5rem; color: #1f2937;',
        h2: 'font-size: 1.875rem; font-weight: 600; line-height: 2.25rem; margin-top: 0.5rem; margin-bottom: 0.5rem; color: #374151;',
        h3: 'font-size: 1.5rem; font-weight: 600; line-height: 2rem; margin-top: 0.5rem; margin-bottom: 0.5rem; color: #4b5563;',
        p: 'font-size: 1rem; line-height: 1.75rem; margin-top: 0.5rem; margin-bottom: 0.5rem; color: #1f2937;',
        ul: 'list-style-type: disc; padding-left: 1.5rem; margin-top: 0.5rem; margin-bottom: 0.5rem;',
        ol: 'list-style-type: decimal; padding-left: 1.5rem; margin-top: 0.5rem; margin-bottom: 0.5rem;',
        li: 'font-size: 1rem; line-height: 1.75rem; margin-top: 0.25rem; margin-bottom: 0.25rem; color: #1f2937;',
        strong: 'font-weight: 700;',
        em: 'font-style: italic;',
        u: 'text-decoration: underline;',
        s: 'text-decoration: line-through;',
    };

    // Nested list styles
    const nestedStyles: Record<string, string> = {
        'ul ul': 'list-style-type: circle; margin-top: 0.25rem; margin-bottom: 0.25rem;',
        'ol ul': 'list-style-type: circle; margin-top: 0.25rem; margin-bottom: 0.25rem;',
        'ol ol': 'list-style-type: lower-alpha; margin-top: 0.25rem; margin-bottom: 0.25rem;',
        'ul ol': 'list-style-type: lower-alpha; margin-top: 0.25rem; margin-bottom: 0.25rem;',
    };

    // Apply basic tag styles
    Object.entries(styles).forEach(([tag, style]) => {
        const elements = doc.querySelectorAll(tag);
        elements.forEach((el) => {
            // Append new styles to existing styles (if any)
            const currentStyle = el.getAttribute('style') || '';
            el.setAttribute('style', `${currentStyle} ${style}`.trim());
        });
    });

    // Apply nested styles (more specific selectors)
    // We need to handle this manually since querySelectorAll works, but we need to ensure we don't overwrite blindly if logic gets complex.
    // For simple nested lists:
    Object.entries(nestedStyles).forEach(([selector, style]) => {
        const elements = doc.querySelectorAll(selector);
        elements.forEach((el) => {
            // These usually trigger on the inner list (ul or ol)
            const currentStyle = el.getAttribute('style') || '';
            // We overwrite list-style-type if it was set by the parent generic 'ul'/'ol' rule
            // But we want to keep other things if they don't conflict, or just append.
            // Since specific wins, existing inline style comes from previous iteration.
            // Let's just append. CSS rules: last one wins in style attribute string? Yes roughly.
            el.setAttribute('style', `${currentStyle} ${style}`.trim());
        });
    });

    return doc.body.innerHTML;
};
